import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/categories";

export default function Footer() {
  return (
    <footer
      className="mt-24 border-t border-neutral-200 bg-neutral-50"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="font-display font-bold text-2xl tracking-tight text-neutral-900">
              Broke<span className="brand-red">Shopping</span>
              <span className="text-neutral-500 font-medium">.com</span>
            </div>
            <p className="text-sm text-neutral-600 mt-3 max-w-sm leading-relaxed">
              A fictional storefront featuring fictional products from fictional
              brands. No trademarks were harmed in the making of this site.
            </p>
            <p className="text-xs text-neutral-500 mt-6">
              © {new Date().getFullYear()} BrokeShopping.com — All prices imaginary.
            </p>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-widest text-neutral-500 mb-3">
              Shop
            </h4>
            <ul className="space-y-2">
              {CATEGORIES.slice(0, 8).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-neutral-700 hover:text-neutral-900 hover:underline underline-offset-4"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-widest text-neutral-500 mb-3">
              More
            </h4>
            <ul className="space-y-2">
              {CATEGORIES.slice(8).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-neutral-700 hover:text-neutral-900 hover:underline underline-offset-4"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-xs uppercase tracking-widest text-neutral-500 mb-3">
              Help
            </h4>
            <ul className="space-y-2 text-sm text-neutral-700">
              <li>Fictional Returns</li>
              <li>Imaginary Shipping</li>
              <li>Made-Up FAQ</li>
              <li>Contact (No One)</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
